// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1l2gz","active":"NavigationItem_active__3C6gP"};